export const COPY_URL_KEY = 'copyUrl'
export const FACEBOOK_KEY = 'facebook'
export const TWITTER_KEY = 'twitter'

export const FACEBOOK_ACCOUNT = 'BobtailYearlings'
export const TWITTER_ACCOUNT = 'BobtailYearling'
